import { render, staticRenderFns } from "./AMEmptinessPhonecase16.vue?vue&type=template&id=1ccec136&scoped=true"
import script from "./AMEmptinessPhonecase16.vue?vue&type=script&lang=ts"
export * from "./AMEmptinessPhonecase16.vue?vue&type=script&lang=ts"
import style0 from "./AMEmptinessPhonecase16.vue?vue&type=style&index=0&id=1ccec136&prod&lang=scss&scoped=true"
import style1 from "./AMEmptinessPhonecase16.vue?vue&type=style&index=1&id=1ccec136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccec136",
  null
  
)

export default component.exports